<template>
    <div class="sub-title-component" :style="{'text-align': align}">
      <span>{{this.text}}</span><slot/>
    </div>
</template>

<script>
export default {
  name: 'SubTitle',
  props: {
    text: {
      type: String,
      required: true,
      default: 'Título',
    },
    align: {
      type: String,
      default: 'left',
    },
  },
};
</script>

<style lang="scss" scoped>
  .sub-title-component {
    min-height: 38px;
    span:first-child {
      font-size: 15px;
      font-weight: 900;
      color: $fb-green;
      text-transform: uppercase;
    }
  }
</style>
